import { request } from '../services/Request';

export function fetchCall(callback, url, method, payload) {
  const headers = {
    'content-type': 'application/x-www-form-urlencoded',
  };
  return new Promise(function(resolve, reject) {
    request(method, url, null, payload, headers)
      .then((res) => {
        callback(res.data);
        resolve(res.data);
      })
      .catch((err) => {
        callback(err);
        return err;
      });
  });
}

export function fetchRegistrationCall(callback, url, method, payload) {
  return new Promise(function(resolve, reject) {
    request(method, url, null, payload, null)
      .then((res) => {
        callback(res.data);
        resolve(res.data);
      })
      .catch((err) => {
        callback(err);
        return err;
      });
  });
}

export function fetchJsonCall(callback, url, method, payload) {
  return new Promise(function(resolve, reject) {
    request(method, url, null, payload, null)
      .then((res) => {
        callback(res.data);
        resolve(res.data);
      })
      .catch((err) => {
        callback(err);
        return err;
      });
  });
}

export function fetchDealerRegistrationCall(callback, url, method, payload) {
  const headers = {
    'content-type': 'application/x-www-form-urlencoded',
  };
  return new Promise(function(resolve, reject) {
    request(method, url, null, payload, headers)
      .then((res) => {
        callback(res.data);
        resolve(res.data);
      })
      .catch((err) => {
        callback(err);
        return err;
      });
  });
}

export function fetcCallImageUpload(callback, url, method, payload) {
  const headers = {
    'content-type': 'multipart/form-data',
  };
  return new Promise(function(resolve, reject) {
    request(method, url, null, payload, headers)
      .then((res) => {
        callback(res.data);
        resolve(res.data);
      })
      .catch((err) => {
        callback(err);
        return err;
      });
  });
}

// getNewDealerbyType - pipeline / approve / reject
export function getNewDealerbyType(callback, url, method, payload) {
  return new Promise(function(resolve, reject) {
    request(method, url, null, payload, null)
      .then((res) => {
        callback(res.data);
        resolve(res.data);
      })
      .catch((err) => {
        callback(err);
        return err;
      });
  });
}

export function promiseJsonCall(url, method, payload) {
  return new Promise(function(resolve, reject) {
    request(method, url, null, payload, null)
      .then((res) => {
        resolve(res.data);  // Resolving with data
      })
      .catch((err) => {
        reject(err);  // Rejecting with error
      });
  });
}
